export default __webpack_public_path__ + "static/SWPS_University.svg-315bb44c0aced298cb4f2ad9f2f57690.png";